import React, { lazy } from 'react';
import styled from 'styled-components';
import css from '@styled-system/css';
import { useLocation } from 'react-router-dom';
import { safeJSONParse } from 'utils/safeJwts';
const Header = lazy(() => import('./header'));
const Footers = lazy(() => import('./footerMain'));
const PlayAudio = lazy(() => import('../PlayAudio'));

export default function Layout({ children }) {
  const location = useLocation();
  const { pathname } = location;
  const title = window.platform_info.title;
  const iosUser = safeJSONParse(localStorage.getItem(`ios_sub_user_${title}`));
  const isFront = pathname == '/';
  const isContentDetails =
    pathname.startsWith('/content/details') ||
    pathname.startsWith('/content/video') ||
    pathname.startsWith('/content/series');
  const isPromotionPage = pathname.startsWith('/fb-promotion');
  const hideHeader =
    iosUser ||
    pathname.startsWith('/reels') ||
    pathname.startsWith('/content/tvodexclusive') ||
    pathname.startsWith('/content/play') ||
    pathname.startsWith('/play') ||
    pathname.startsWith('/fb-promotion');

  const hideFooter =
    pathname.startsWith('/content/tvodexclusive') ||
    pathname.startsWith('/content/play') ||
    pathname.startsWith('/play') ||
    pathname.startsWith('/fb-promotion');

  return (
    <RootBox>
      {!hideHeader && <Header front={isFront} contentDetails={isContentDetails} />}
      <Main front={isFront} contentDetails={isContentDetails} promotionPage={isPromotionPage}>
        {children}
      </Main>
      {!hideFooter && <Footers />}
      <PlayAudio />
    </RootBox>
  );
}

const RootBox = styled('div')(
  css({
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    minWidth: '100%',
    justifyContent: 'space-between'
  })
);

const Main = styled('main')((props) =>
  css({
    paddingBottom: `${props.promotionPage ? '0' : 150}`,
    marginTop: `${props.front || props.contentDetails ? '-92px' : 0}`,
    '@media (max-width: 920px)': {
      marginTop: `${props.front ? '0px' : 0}`
    },
    '@media (max-width: 639px)': {
      marginTop: `${props.front ? '-122px' : 0}`,
      paddingBottom: 0,
      minHeight: 'calc(85vh - 300px)'
    },

    zIndex: 111,
    overflow: 'hidden',
    minHeight: ['calc(100vh - 300px)', 'calc(100vh - 200px)']
  })
);
